import React, { Component } from 'react';
import Reflux from 'reflux';

class PanelBody extends Component {
  render() {
    return (
      <div className="panel-body" style={{ padding: 0 }}>
        {this.props.children}
      </div>
    );
  }
}

export { PanelBody };
